<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 400 113"
    :width="props.width"
    :height="props.height"
    :style="{ fill: props.fill }"
  >
    <g>
      <path
        :class="{ st3: !props.fill }"
        d="M73.37,112.51v-13.28h5.5c.57,0,1.1.12,1.58.36.48.24.89.56,1.24.95s.62.84.81,1.34c.19.5.29,1,.29,1.51,0,.55-.09,1.08-.27,1.58s-.44.95-.78,1.34c-.34.39-.74.7-1.21.94-.47.24-.99.36-1.56.36h-4.32v4.9h-1.29ZM74.66,106.45h4.24c.39,0,.74-.08,1.06-.25.32-.17.59-.39.81-.67s.4-.6.52-.97.19-.75.19-1.15-.07-.8-.21-1.17c-.14-.37-.34-.69-.58-.96-.24-.27-.53-.49-.86-.65-.33-.16-.68-.23-1.04-.23h-4.13v6.06Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M105.83,99.24v13.28h-1.31v-6.21h-7.87v6.21h-1.29v-13.28h1.29v5.91h7.87v-5.91h1.31Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M118.16,112.51l5.55-13.28h1.07l5.55,13.28h-1.4l-1.72-4.15h-5.97l-1.7,4.15h-1.38ZM124.25,100.77l-2.73,6.56h5.39l-2.66-6.56Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M142.64,112.51v-13.28h5.59c.57,0,1.1.12,1.59.36.49.24.9.56,1.25.95.35.39.62.84.81,1.34.19.5.29,1,.29,1.51s-.07.95-.21,1.39c-.14.44-.35.84-.61,1.2-.26.36-.57.65-.94.9-.36.24-.77.41-1.21.5l3.27,5.12h-1.48l-3.14-4.9h-3.93v4.9h-1.29ZM143.93,106.45h4.36c.39,0,.74-.08,1.06-.25.32-.17.59-.4.81-.68s.4-.61.52-.97c.12-.36.19-.74.19-1.14s-.07-.78-.21-1.15c-.14-.37-.34-.69-.58-.96-.24-.27-.53-.49-.86-.65-.33-.16-.68-.24-1.04-.24h-4.24v6.06Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M177.12,112.51v-10.9l-4.84,8.43h-.77l-4.86-8.43v10.9h-1.29v-13.28h1.33l5.2,9.09,5.2-9.09h1.33v13.28h-1.29Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M190.75,112.51l5.55-13.28h1.07l5.55,13.28h-1.4l-1.72-4.15h-5.97l-1.7,4.15h-1.38ZM196.85,100.77l-2.73,6.56h5.39l-2.66-6.56Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M214.37,105.78c0-.8.14-1.59.42-2.38.28-.79.69-1.5,1.22-2.12.54-.62,1.2-1.13,1.98-1.52s1.68-.59,2.67-.59c1.18,0,2.19.27,3.03.8.83.54,1.46,1.23,1.87,2.09l-1.05.64c-.21-.44-.47-.8-.77-1.1-.3-.3-.62-.54-.97-.73-.35-.19-.71-.32-1.09-.4s-.74-.12-1.1-.12c-.8,0-1.5.16-2.11.49-.61.32-1.13.75-1.54,1.27-.42.52-.73,1.11-.95,1.77-.21.65-.32,1.32-.32,1.99,0,.74.13,1.44.38,2.11.26.67.6,1.27,1.05,1.79s.97.93,1.57,1.23c.6.31,1.26.46,1.97.46.37,0,.76-.05,1.15-.14.39-.09.77-.24,1.14-.45.37-.21.71-.46,1.02-.77.31-.31.57-.68.79-1.11l1.09.56c-.21.5-.51.94-.9,1.32-.39.38-.82.7-1.29.96-.47.26-.98.46-1.51.6s-1.05.21-1.56.21c-.91,0-1.75-.2-2.51-.6-.76-.4-1.42-.92-1.96-1.56-.55-.64-.98-1.37-1.28-2.19-.31-.82-.46-1.65-.46-2.5Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M247.41,111.35v1.16h-8.92v-13.28h8.75v1.16h-7.46v4.79h6.51v1.1h-6.51v5.07h7.63Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M265.71,111.43c.83,0,1.53-.16,2.09-.48.55-.32,1-.74,1.33-1.25.33-.52.56-1.11.69-1.77.13-.66.2-1.33.2-2v-6.69h1.31v6.69c0,.9-.1,1.75-.3,2.55-.2.8-.52,1.51-.96,2.12s-1.02,1.1-1.73,1.46c-.71.36-1.58.54-2.6.54s-1.94-.19-2.66-.57c-.71-.38-1.28-.88-1.72-1.51-.44-.62-.75-1.33-.94-2.13-.19-.8-.28-1.62-.28-2.47v-6.69h1.29v6.69c0,.7.07,1.38.21,2.04.14.66.37,1.25.7,1.76.33.51.77.92,1.32,1.23.55.31,1.23.47,2.06.47Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M294.28,100.39h-4.73v12.12h-1.31v-12.12h-4.73v-1.16h10.77v1.16Z"
      />
      <path :class="{ st3: !props.fill }" d="M306.7,112.51v-13.26h1.29v13.26h-1.29Z" />
      <path
        :class="{ st3: !props.fill }"
        d="M320.87,105.78c0-.8.14-1.59.42-2.38.28-.79.69-1.5,1.22-2.12.54-.62,1.2-1.13,1.98-1.52s1.68-.59,2.67-.59c1.18,0,2.19.27,3.03.8.83.54,1.46,1.23,1.87,2.09l-1.05.64c-.21-.44-.47-.8-.77-1.1-.3-.3-.62-.54-.97-.73-.35-.19-.71-.32-1.09-.4s-.74-.12-1.1-.12c-.8,0-1.5.16-2.11.49-.61.32-1.13.75-1.54,1.27-.42.52-.73,1.11-.95,1.77-.21.65-.32,1.32-.32,1.99,0,.74.13,1.44.38,2.11.26.67.6,1.27,1.05,1.79s.97.93,1.57,1.23c.6.31,1.26.46,1.97.46.37,0,.76-.05,1.15-.14.39-.09.77-.24,1.14-.45.37-.21.71-.46,1.02-.77.31-.31.57-.68.79-1.11l1.09.56c-.21.5-.51.94-.9,1.32-.39.38-.82.7-1.29.96-.47.26-.98.46-1.51.6s-1.05.21-1.56.21c-.91,0-1.75-.2-2.51-.6-.76-.4-1.42-.92-1.96-1.56-.55-.64-.98-1.37-1.28-2.19-.31-.82-.46-1.65-.46-2.5Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M343.41,112.51l5.55-13.28h1.07l5.55,13.28h-1.4l-1.72-4.15h-5.97l-1.7,4.15h-1.38ZM349.5,100.77l-2.73,6.56h5.39l-2.66-6.56Z"
      />
      <path :class="{ st3: !props.fill }" d="M367.89,112.51v-13.28h1.29v12.12h7.69v1.16h-8.98Z" />
      <path
        :class="{ st3: !props.fill }"
        d="M397,101.72c-.37-.42-.88-.77-1.51-1.03-.63-.26-1.34-.39-2.12-.39-1.18,0-2.05.22-2.58.66-.54.44-.8,1.04-.8,1.8,0,.4.07.73.21.98.14.26.37.48.67.66.31.19.69.35,1.16.49.47.14,1.02.27,1.66.41.71.15,1.35.31,1.91.5.56.18,1.04.41,1.44.69.4.28.7.62.92,1.03.21.4.32.91.32,1.51s-.12,1.14-.36,1.59c-.24.45-.57.82-.99,1.12-.42.3-.93.52-1.51.66-.59.14-1.22.21-1.91.21-2.08,0-3.86-.64-5.33-1.93l.64-1.07c.49.51,1.14.94,1.96,1.3.82.36,1.74.53,2.75.53,1.06,0,1.89-.19,2.49-.57.6-.38.9-.96.9-1.73,0-.41-.08-.76-.25-1.04-.17-.28-.42-.52-.76-.73-.34-.21-.76-.38-1.26-.53-.5-.15-1.09-.3-1.75-.45-.7-.16-1.31-.33-1.83-.5-.52-.17-.96-.39-1.32-.65-.36-.26-.62-.58-.8-.94-.18-.37-.27-.82-.27-1.36,0-.61.11-1.16.35-1.64.23-.48.55-.88.97-1.2.42-.32.92-.56,1.5-.73.58-.17,1.22-.25,1.92-.25.87,0,1.66.13,2.35.4s1.32.65,1.88,1.13l-.62,1.05Z"
      />
    </g>
    <g>
      <path
        :class="{ st3: !props.fill }"
        d="M2.4,37c.34-7.78,4-12.81,9.27-15.9,5.26-2.97,12.13-4.12,18.88-4.12,14.07,0,27.69,3.09,27.69,19.91v25.97c0,5.03,0,10.53,2.29,15.22h-19.56c-.69-1.83-.92-3.66-1.15-5.61-5.03,5.26-12.47,7.32-19.56,7.32C8.92,79.79,0,74.07,0,61.83,0,42.49,21.05,43.98,34.55,41.24c3.32-.69,5.15-1.83,5.15-5.49,0-4.46-5.38-6.18-9.38-6.18-5.38,0-8.81,2.4-9.73,7.44H2.4ZM27.57,67.78c9.27,0,12.36-5.26,11.9-17.5-2.75,1.72-7.78,2.06-12.01,3.2-4.35,1.03-8.01,2.86-8.01,7.55s3.77,6.75,8.12,6.75Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M65.44,18.7h18.88v10.41h.23c2.86-7.55,9.5-11.56,17.85-11.56,1.49,0,3.09.11,4.58.46v17.73c-2.52-.69-4.81-1.14-7.44-1.14-9.61,0-14.64,6.64-14.64,14.07v29.4h-19.45V18.7Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M113.6,18.7h18.88v10.41h.23c2.86-7.55,9.5-11.56,17.85-11.56,1.49,0,3.09.11,4.58.46v17.73c-2.52-.69-4.81-1.14-7.44-1.14-9.61,0-14.64,6.64-14.64,14.07v29.4h-19.45V18.7Z"
      />
    </g>
    <g>
      <path
        :class="{ st3: !props.fill }"
        d="M299.32,53.13c.34,8.12,5.03,13.5,13.27,13.5,4.69,0,9.27-2.17,11.1-6.52h18.19c-3.55,13.73-16.25,19.68-29.52,19.68-19.34,0-32.49-11.67-32.49-31.58,0-18.19,14.53-31.23,32.03-31.23,21.28,0,31.92,16.02,31,36.15h-43.59ZM323.46,42.27c-.34-6.64-5.03-12.13-11.56-12.13-6.86,0-11.44,4.92-12.59,12.13h24.14Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M357.55,46.96l-18.88-28.26h21.51l8.35,14.19,8.35-14.19h20.59l-18.53,27.92,21.05,31.46h-21.51l-10.3-17.16-9.72,17.16h-21.51l20.59-31.12Z"
      />
      <path
        :class="{ st3: !props.fill }"
        d="M277.47,31.28v-12.59h-12.01V.37l-19.45,8.26v10.07h-9.84v12.59h9.84v26.43c0,16.13,4.23,20.94,20.82,20.94,3.55,0,7.09-.46,10.64-.57v-14.3c-1.72,0-3.43.23-5.03.23-4.23,0-6.98-1.03-6.98-5.72v-27h12.01Z"
      />
    </g>
    <rect :class="{ st3: !props.fill }" x="2.35" y="106.45" width="56.04" height="1.16" />
    <g>
      <path
        :class="{ st4: !props.fill }"
        d="M165.09,34.22c-.69,2.69-2.63,4.85-3.68,4.95-1.05.1-.88-1.53-.34-3.87s1.52-4.71,2.81-5.09c1.29-.37,1.89,1.32,1.2,4.01Z"
      />
      <path
        :class="{ st2: !props.fill }"
        d="M163.05,46.43c0,2.87-1.33,5.02-2.32,4.79-.99-.23-1.18-2.39-1.18-4.79s.19-4.56,1.18-4.79c.99-.23,2.32,1.92,2.32,4.79Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M165.09,58.64c.69,2.69.09,4.38-1.2,4.01-1.29-.37-2.27-2.75-2.81-5.09s-.71-3.97.34-3.87c1.05.1,2.98,2.26,3.68,4.95Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M231.59,35.3c.54,2.34.71,3.97-.34,3.87-1.05-.1-2.98-2.26-3.68-4.95-.69-2.69-.09-4.38,1.2-4.01,1.29.37,2.27,2.75,2.81,5.09Z"
      />
      <path
        :class="{ st2: !props.fill }"
        d="M233.13,46.43c0,2.4-.19,4.56-1.18,4.79-.99.23-2.32-1.92-2.32-4.79s1.33-5.02,2.32-4.79c.99.23,1.18,2.39,1.18,4.79Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M231.59,57.56c-.54,2.34-1.52,4.71-2.81,5.09-1.29.37-1.89-1.32-1.2-4.01s2.63-4.85,3.68-4.95c1.05-.1.88,1.53.34,3.87Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M179.02,20.2c-.44,2.09-2.88,4.36-5.22,4.8-2.34.43-3.57-1.01-3.05-3.08.51-2.07,2.65-3.94,4.91-4.39s3.81.58,3.36,2.67Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M176.02,32.37c-.16,2.85-2.36,5.41-4.62,5.6-2.27.19-3.72-1.85-3.63-4.51.1-2.66,2.11-4.91,4.37-5.31,2.26-.4,4.04,1.38,3.88,4.23Z"
      />
      <path
        :class="{ st2: !props.fill }"
        d="M175.63,46.43c0,3.35-2.3,5.95-4.81,5.8-2.51-.15-4.21-2.75-4.21-5.8s1.7-5.66,4.21-5.8c2.51-.15,4.81,2.45,4.81,5.8Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M176.02,60.49c.16,2.85-1.61,4.63-3.88,4.23-2.26-.4-4.28-2.65-4.37-5.31s1.36-4.71,3.63-4.51c2.27.19,4.46,2.76,4.62,5.6Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M179.02,72.66c.44,2.09-1.1,3.12-3.36,2.67-2.26-.45-4.39-2.32-4.91-4.39s.72-3.51,3.05-3.08c2.34.43,4.77,2.71,5.22,4.8Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M221.93,21.92c.51,2.07-.72,3.51-3.05,3.08-2.34-.43-4.77-2.71-5.22-4.8-.44-2.09,1.1-3.12,3.36-2.67,2.26.45,4.39,2.32,4.91,4.39Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M224.9,33.46c.09,2.66-1.36,4.71-3.63,4.51-2.27-.19-4.46-2.76-4.62-5.6-.16-2.85,1.61-4.63,3.88-4.23,2.26.4,4.28,2.65,4.37,5.31Z"
      />
      <path
        :class="{ st2: !props.fill }"
        d="M226.07,46.43c0,3.05-1.7,5.66-4.21,5.8-2.51.15-4.81-2.45-4.81-5.8s2.3-5.95,4.81-5.8c2.51.15,4.21,2.75,4.21,5.8Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M224.9,59.4c-.09,2.66-2.11,4.91-4.37,5.31-2.26.4-4.04-1.38-3.88-4.23.16-2.85,2.36-5.41,4.62-5.6,2.27-.19,3.72,1.85,3.63,4.51Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M221.93,70.94c-.51,2.07-2.65,3.94-4.91,4.39-2.26.45-3.81-.58-3.36-2.67.44-2.09,2.88-4.36,5.22-4.8,2.34-.43,3.57,1.01,3.05,3.08Z"
      />
      <path
        :class="{ st1: !props.fill }"
        d="M193.87,10.74c.06.99-2.07,2.75-4.86,3.28-2.78.53-4.86-.45-4.5-1.56.36-1.11,2.73-1.75,5.09-2.17,2.36-.42,4.21-.55,4.27.44Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M193.62,19.24c-.08,2.05-2.8,4.05-6.01,4.13-3.21.09-5.47-1.81-5.1-3.89.37-2.09,3.03-3.48,5.95-3.52,2.92-.05,5.25,1.24,5.17,3.28Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M193.36,31.08c-.03,3.27-2.9,6.09-6.31,6.16s-5.95-2.59-5.77-5.77c.18-3.18,2.92-5.64,6.18-5.75,3.26-.11,5.93,2.1,5.9,5.37Z"
      />
      <path
        :class="{ st2: !props.fill }"
        d="M193.28,46.43c0,3.53-2.85,6.36-6.28,6.31s-6.12-2.87-6.12-6.31,2.7-6.27,6.12-6.31,6.28,2.78,6.28,6.31Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M193.36,61.78c.03,3.27-2.64,5.47-5.9,5.37-3.26-.11-6-2.57-6.18-5.75-.18-3.18,2.36-5.84,5.77-5.77s6.27,2.89,6.31,6.16Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M193.62,73.61c.08,2.05-2.25,3.33-5.17,3.28-2.92-.05-5.58-1.44-5.95-3.52-.37-2.09,1.89-3.98,5.1-3.89,3.21.09,5.94,2.08,6.01,4.13Z"
      />
      <path
        :class="{ st1: !props.fill }"
        d="M193.87,82.12c-.06.99-1.91.85-4.27.44-2.36-.42-4.73-1.06-5.09-2.17-.36-1.11,1.72-2.09,4.5-1.56,2.78.53,4.92,2.29,4.86,3.28Z"
      />
      <path
        :class="{ st1: !props.fill }"
        d="M208.16,12.47c.36,1.11-1.72,2.09-4.5,1.56-2.78-.53-4.92-2.29-4.86-3.28.06-.99,1.9-.85,4.27-.44s4.73,1.06,5.09,2.17Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M210.17,19.48c.37,2.09-1.89,3.98-5.1,3.89-3.21-.09-5.94-2.08-6.01-4.13-.08-2.05,2.25-3.33,5.17-3.28,2.92.05,5.58,1.44,5.95,3.52Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M211.4,31.46c.18,3.18-2.36,5.84-5.77,5.77-3.41-.06-6.27-2.89-6.31-6.16s2.64-5.47,5.9-5.37,6,2.57,6.18,5.75Z"
      />
      <path
        :class="{ st2: !props.fill }"
        d="M211.79,46.43c0,3.44-2.7,6.27-6.12,6.31-3.42.04-6.28-2.78-6.28-6.31s2.85-6.36,6.28-6.31c3.42.04,6.12,2.87,6.12,6.31Z"
      />
      <path
        :class="{ st4: !props.fill }"
        d="M211.4,61.4c-.18,3.18-2.92,5.64-6.18,5.75-3.26.11-5.93-2.1-5.9-5.37.03-3.27,2.9-6.09,6.31-6.16,3.41-.06,5.95,2.59,5.77,5.77Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M210.17,73.37c-.37,2.09-3.03,3.48-5.95,3.52-2.92.05-5.25-1.24-5.17-3.28.08-2.05,2.8-4.05,6.01-4.13,3.21-.09,5.47,1.81,5.1,3.89Z"
      />
      <path
        :class="{ st1: !props.fill }"
        d="M208.16,80.39c-.36,1.11-2.73,1.75-5.09,2.17s-4.21.55-4.27-.44c-.06-.99,2.07-2.75,4.86-3.28,2.78-.53,4.86.45,4.5,1.56Z"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface SVGProps {
  height: string
  width: string
  fill?: string
}

const props = defineProps<SVGProps>()
</script>

<style scoped>
.st0 {
  fill: #66bad7;
}

.st1 {
  fill: #99d1e4;
}

.st2 {
  fill: #008dbc;
}

.st3 {
  fill: #4d4d4f;
}

.st4 {
  fill: #33a4c9;
}
</style>
